<template>
  <div>
    <v-card
      min-height="700px"
      flat
      outlined
      class="pa-3"
    >
      <v-card-text>
        <v-row
          no-gutters
          class="justify-center"
        >
          <v-col
            cols="12"
            sm="5"
          >
            <v-stepper v-model="stepperCount">
              <v-stepper-header>
                <v-stepper-step
                  :complete="stepperCount > 1"
                  step="1"
                  editable
                >
                  ONLINE PAYMENT SETTINGS
                </v-stepper-step>
                <v-divider />
                <v-stepper-step
                  :complete="stepperCount > 2"
                  step="2"
                  :editable="isValid"
                >
                  {{ gatewayName ? gatewayName : "GATEWAY" }} SETTINGS
                </v-stepper-step>
              </v-stepper-header>

              <v-divider />

              <v-stepper-items>
                <v-stepper-content
                  step="1"
                  class="pa-0"
                >
                  <v-card>
                    <v-card-text class="pa-6">
                      <v-form
                        id="store_payment_gateway_register"
                        ref="form"
                        v-model="isValid"
                      >
                        <v-row>
                          <v-col cols="12">
                            <v-text-field
                              id="gate_way_name"
                              ref="gate_way_name"
                              v-model="storeConfig.name"
                              name="account_Name"
                              label="Name"
                              type="text"
                              autofocus
                              outlined
                              dense
                              required
                              :rules="nameRules"
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-textarea
                              id="gate_way_description"
                              v-model="storeConfig.description"
                              label="Description"
                              two-line
                              outlined
                              hide-details
                              dense
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-autocomplete
                              id="gateway_id"
                              v-model="storeConfig.gatewayID"
                              :items="paymentGateways"
                              item-text="name"
                              item-value="id"
                              label="Payment Gateway mode"
                              open-on-clear
                              required
                              outlined
                              dense
                              :rules="modeRules"
                            />
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-card-text>
                    <v-divider />
                    <v-card-actions class="px-6 py-3">
                      <v-spacer />
                      <v-btn
                        id="register_save"
                        color="success"
                        class="white--text"
                        :disabled="!isValid"
                        :loading="loader"
                        @click.native="saveOnlinePaymentAccount()"
                      >
                        {{ storeConfig.id ? "Update" : "Save" }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>

                <v-stepper-content
                  step="2"
                  class="pa-0"
                >
                  <v-card>
                    <v-card-text class="pa-6">
                      <v-form
                        id="store_payment_gateway_register"
                        ref="new_form"
                        v-model="gtFormValid"
                      >
                        <!-- RAZORPAY fields -->
                        <v-row
                          v-if="storeConfig && storeConfig.gatewayID == 2"
                          no-gutters
                        >
                          <v-col cols="12">
                            <v-text-field
                              id="user_name"
                              v-model="gtConfig.mID"
                              name="mid"
                              label="MID"
                              type="text"
                              autofocus
                              outlined
                              dense
                              :rules="midRules"
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              id="user_name"
                              v-model="gtConfig.keyID"
                              name="keyID"
                              label="Key ID"
                              type="text"
                              outlined
                              dense
                              :rules="keyIdRules"
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              id="keySecret"
                              v-model="gtConfig.keySecret"
                              name="keySecret"
                              label="Key Secret"
                              type="text"
                              outlined
                              dense
                              :rules="keySecretRules"
                            />
                          </v-col>
                        </v-row>

                        <!-- easebuzz configuration -->
                        <v-row
                          v-if="storeConfig && storeConfig.gatewayID == 1"
                          no-gutters
                        >
                          <v-col cols="12">
                            <v-text-field
                              v-model="gtConfig.keyID"
                              label="Key ID"
                              type="text"
                              outlined
                              dense
                              :rules="keyIdRules"
                            />
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              id="keySecret"
                              v-model="gtConfig.keySecret"
                              name="keySecret"
                              label="Key Secret"
                              type="text"
                              outlined
                              dense
                              :rules="keySecretRules"
                            />
                          </v-col>
                        </v-row>

                        <!-- zomato pay configuration -->
                        <v-row
                          v-if="storeConfig && storeConfig.gatewayID == 3"
                          no-gutters
                        >
                          <v-col cols="12">
                            <v-text-field
                              v-model="gtConfig.keySecret"
                              name="keySecret"
                              label="Key Secret"
                              type="text"
                              outlined
                              dense
                              :rules="keySecretRules"
                            />
                          </v-col>
                        </v-row>

                        <!-- Obvvy configuration -->
                        <v-row
                          v-if="storeConfig && storeConfig.gatewayID == 4"
                          no-gutters
                        >
                          <v-col cols="12">
                            <v-text-field
                              v-model="gtConfig.keySecret"
                              name="keySecret"
                              label="Key Secret"
                              type="text"
                              outlined
                              dense
                              :rules="keySecretRules"
                            />
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-card-text>
                    <v-divider />
                    <v-card-actions class="px-6 py-3">
                      <v-spacer />
                      <v-btn
                        id="register_save"
                        color="success"
                        class="white--text"
                        :disabled="!gtFormValid"
                        :loading="loader"
                        @click.native="saveGatewayAccount()"
                      >
                        {{ gtConfig.id ? "Update" : "Save" }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "OnlinePaymentConfig",
  data() {
    return {
      storeId: parseInt(this.$route.params.storeId),
      accountId: parseInt(this.$route.params.accountId),
      storeConfig: {},
      loader: false,
      isValid: false,
      paymentGateways: [
        { id: 1, name: "Easebuzz" },
        { id: 2, name: "Hdfc Razorpay" },
        { id: 3, name: "Zomato Pay" },
        { id: 4, name: "Obvvy Pay" }
      ],
      nameRules: [
        (v) => !!v || "Name is required",
        (v) =>
          (v && v.length <= 25) ||
          "Display name must be less than 25 characters"
      ],
      stepperCount: 1,
      gtFormValid: false,
      gtLoader: false,
      gtConfig: {},
      modeRules: [(v) => !!v || "Payment mode is required"],
      apiKeyRules: [(v) => !!v || "API Key is required"],
      merchantIDRules: [(v) => !!v || "Merchant ID is required"],
      midRules: [(v) => !!v || "MID is required"],
      keyIdRules: [(v) => !!v || "Key ID is required"],
      keySecretRules: [(v) => !!v || "Key Secret is required"],
      requiredRules: [(v) => !!v || "required"]
    };
  },
  computed: {
    gatewayName() {
      switch (this.storeConfig.gatewayID) {
        case 1:
          return "EASEBUZZ";
        case 2:
          return "Hdfc Razorpay";
        case 3:
          return "ZOMATO PAY";
          case 4:
          return "OBVVY PAY";
        default:
          return null;
      }
    }
  },
  watch: {
    stepperCount(v) {
      if (v && v === "2") {
        this.getGatewayAccount();
      }
    }
  },
  created() {
    this.init();
  },
  methods: {
    next() {
      this.stepperCount = 2;
      this.getGatewayAccount();
    },
    goBack() {
      this.stepperCount--;
    },
    getGatewayAccount() {
      let gateWayId = (this.storeConfig && this.storeConfig.gatewayID) || null;
      if (!gateWayId) {
        return;
      }
      this.gtLoader = true;
      let url = `${this.PAYMENT_APP_URL}/api/v1/stores/${this.storeId}/gateways/${gateWayId}`;
      this.$http.get(url).then(
        (res) => {
          this.gtConfig = res.body || {};
          this.gtLoader = false;
        },
        (failure) => {
          console.error("Not Configured", { failure });
          this.loader = false;
        }
      );
    },
    saveGatewayAccount() {
      let gateWayId = (this.storeConfig && this.storeConfig.gatewayID) || null;
      if (!gateWayId) {
        return;
      }
      this.gtConfig.accountID = this.storeConfig.id;
      this.gtConfig.storeID = this.storeId;
      let url = `${this.PAYMENT_APP_URL}/api/v1/stores/${this.storeId}/gateways/${gateWayId}`;
      this.$http.put(url, this.gtConfig).then(
        (res) => {
          this.handleSuccess(res.body);
          this.getGatewayAccount();
        },
        (failure) => {
          this.loader = false;
          this.handleFailure(failure);
        }
      );
    },
    saveOnlinePaymentAccount() {
      this.storeConfig.accountID = this.accountId;
      let url = `${this.PAYMENT_APP_URL}/api/v1/stores/${this.storeId}`;
      this.$http.put(url, this.storeConfig).then(
        (res) => {
          this.storeConfig.id = res.body.id;
          this.handleSuccess(res.body);
          this.next();
        },
        (failure) => {
          this.loader = false;
          this.handleFailure(failure);
        }
      );
    },
    getOnlinePaymentAccount() {
      this.loader = true;
      let url = `${this.PAYMENT_APP_URL}/api/v1/stores/${this.storeId}`;
      this.$http.get(url).then(
        (res) => {
          this.storeConfig = res.body || null;
          this.loader = false;
        },
        (failure) => {
          console.error("Not Configured", { failure });
          this.loader = false;
        }
      );
    },
    init() {
      this.getOnlinePaymentAccount();
    },
    handleSuccess(response) {
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.message
      });
      this.$emit("reload");
    },
    handleFailure(failure) {
      let msg = (failure && failure.body && failure.body.error  ) || "Error";
      this.$store.commit("showSnackbar", {
        message: msg,
        color: "error"
      });
    }
  }
};
</script>